import type { IconNode } from '../types';

/**
 * @name house-roof
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMi42IDEwLjRhMi4xMiAyLjEyIDAgMSAwIDMuMDIgMi45OEwxMiA3bDYuNCA2LjRhMi4xMiAyLjEyIDAgMSAwIDIuOTc5LTMuMDIxTDEzLjcgMi43YTIuNCAyLjQgMCAwIDAtMy40MDQuMDA0WiIgLz4KICA8cGF0aCBkPSJNMjAgMTR2NmEyIDIgMCAwIDEtMiAySDZhMiAyIDAgMCAxLTItMnYtNiIgLz4KICA8cGF0aCBkPSJNMTQgMjJ2LTZhMiAyIDAgMCAwLTQgMHY2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/house-roof
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const houseRoof: IconNode = [
  [
    'path',
    {
      d: 'M2.6 10.4a2.12 2.12 0 1 0 3.02 2.98L12 7l6.4 6.4a2.12 2.12 0 1 0 2.979-3.021L13.7 2.7a2.4 2.4 0 0 0-3.404.004Z',
      key: 'lwty51',
    },
  ],
  ['path', { d: 'M20 14v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6', key: 'wgcysu' }],
  ['path', { d: 'M14 22v-6a2 2 0 0 0-4 0v6', key: '18j3a0' }],
];

export default houseRoof;
